import React, { useRef, useEffect } from 'react'
import { useFormPageHandler } from 'irmlib/hooks'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { TextField } from 'irmlib/components/FormControls'
import PropTypes from 'prop-types'
import { YDivider } from 'irmlib/styles'
import { useTranslation } from 'react-i18next'
import { OutlinedButton, ContainedButton } from 'irmlib/components/Controls'
import { Grid } from '@material-ui/core'
import { errorToast } from '../../../common/functions.js'

const TOTAL_FILES = 0
const getService = async (setState) => {
  const getObject = {
  }
  return Promise.resolve(getObject)
}

export const LocalActivitySubmitImagesModal = (props) => {
  const { handleShowModal, handleSubmitImages, reqData } = props
  const { t } = useTranslation()
  const refLocalBusyCursor = useRef(null)
  const [open, setOpen] = React.useState(props.showModal)

  const formTemplate = [
    {
      label: 'smartCatalog.totFiles',
      fieldKey: 'totFiles',
      defaultValue: 1,
      isRequired: true
    },
    {
      label: 'smartCatalog.totBoxes',
      fieldKey: 'totBoxes',
      isRequired: true
    },
  ]

  const [arrRefs, data] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor,
  })

  const handleClose = () => {
    setOpen(false)
    handleShowModal(false)
  }

  const saveActivity = () => {
    const totNoOfFiles = Number(arrRefs[TOTAL_FILES]?.current?.getValue())
    if (!totNoOfFiles || totNoOfFiles < 1 || totNoOfFiles > 6) {
      errorToast({ message: t('forms.required'), title: t('toast.error') })
      return
    }
    handleSubmitImages(totNoOfFiles, 0, reqData)
    setOpen(false)
    handleShowModal(false)
  }
  useEffect(() => {
    if (!open) return
    const timer = setTimeout(() => {
      const input = document.getElementById('submitImages_totFiles')
      const nativeInput = input?.querySelector?.('input') ?? input
      if (nativeInput && typeof nativeInput.select === 'function') {
        // nativeInput.focus()
        nativeInput.select()
      }
    }, 150)
    return () => clearTimeout(timer)
  }, [open])

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Enter') {
        event.preventDefault() 
        saveActivity()
      }
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [])
  const VerticalDivider = () => <YDivider height="20px" />
  return (
    <React.Fragment>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth='xs'>
        <DialogTitle>{t('smartCatalog.assetSummary')}</DialogTitle>
        <DialogContent>
          <>
            <VerticalDivider />
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  // type={'number'}
                  id={'submitImages_totFiles'}
                  inputProps={{
                    maxLength: 1,
                    inputMode: 'numeric',
                    pattern: '[1-6]*',
                    onInput: (e) => {
                      e.target.value = e?.target?.value?.replace(/[^1-6]/g, '')
                    }
                  }}
                  helperText={t('messages.allowedLimit')}
                  data={data}
                  fieldTemplate={formTemplate[TOTAL_FILES]}
                  ref={arrRefs[TOTAL_FILES]}
                  style={{ marginBottom: '20px' }}
                  autoFocus
                />
              </Grid>
            </Grid>
          </>
        </DialogContent>
        <DialogActions sx={{ pb: 2, pr: 2 }}>
          <OutlinedButton 
            style={{ width: '80px', height: '36.5px', margin: '5px' }}
            onClick={handleClose}
          >
            buttons.cancel
          </OutlinedButton>
          <ContainedButton 
            style={{ width: '80px', height: '36.5px', margin: '5px' }}
            onClick={saveActivity}
          >
            buttons.save
          </ContainedButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

LocalActivitySubmitImagesModal.propTypes = {
  showModal: PropTypes.bool,
  handleShowModal: PropTypes.func,
  handleSubmitImages: PropTypes.func,
  reqData: PropTypes.object,
}